<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import PatternSetupForm from "../../../components/attendance/patternsetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": PatternSetupForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setuppattern.createnewpattern'),
      pageTitleValue: "",
      formData: {
        code: null,
        name: null,
        cycledays: null,
        remark: null,
        rdaygzactionid:  1,
        rdayngzactionid: 1,
        ofdaygzactionid:  1,
        ofdayngzactionid: 1,
        disable: false,
        patternd: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      if (this.formData.disable == false || this.formData.disable == null) {
        this.formData.disable = 0;
      } else {
        this.formData.disable = 1;
      }

      this.$store.dispatch("post", { url: "/patternsetup/create", payload: vm.formData })
        .then(res => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "patternsetupedit", params: { id: res.data.id } });
          }
        })
        .catch(err => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "patternsetuplist" });
    },
  },
};
</script>
